import type { Group, ServicePlan } from '@app/types';

export type SetlistMode = 'leader_builds' | 'admin_predefined';

/** Per-plan override > team default > leader builds. */
export const effectiveSetlistMode = (plan: Pick<ServicePlan, 'setlistModeOverride'> | null | undefined, group: Pick<Group, 'setlistMode'> | null | undefined): SetlistMode =>
  ((plan?.setlistModeOverride || group?.setlistMode || 'leader_builds') as SetlistMode);

export interface SetlistView {
  mode: SetlistMode;
  /** Team / Setlist segmented control. Only for an admin-built setlist that is published. */
  showToggle: boolean;
  /** "Build setlist" entry point: admin-built, not yet published, and still upcoming. */
  canBuild: boolean;
  /** The per-service mode Select and every other edit are for upcoming services only. */
  readOnly: boolean;
  /** "Send lyrics email" is offered once the setlist is published. */
  canSendLyrics: boolean;
}

export function setlistView(
  plan: Pick<ServicePlan, 'setlistModeOverride' | 'isSetlistPublished' | 'date'>,
  group: Pick<Group, 'setlistMode'> | null | undefined,
  now: Date = new Date(),
): SetlistView {
  const mode = effectiveSetlistMode(plan, group);
  const readOnly = new Date(plan.date).getTime() < now.getTime();
  const published = !!plan.isSetlistPublished;
  return {
    mode,
    showToggle: mode === 'admin_predefined' && published,
    canBuild: mode === 'admin_predefined' && !published && !readOnly,
    readOnly,
    canSendLyrics: published,
  };
}

export const SETLIST_MODE_LABEL: Record<SetlistMode, string> = {
  leader_builds: 'Worship leader builds',
  admin_predefined: 'Admin predefined',
};
